"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIntlSecond = exports.checkIntlMinute = exports.checkIntlDay = exports.checkIntlMonth = exports.checkIntlYear = exports.isNumber = exports.isValidDateTimeIntl = exports.NOT_VALID = void 0;

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PIVOT_YEAR_4D = 1970; // A pivot year used for converting 2-digit year into a 4-digit year. (Momentjs implementation)

var PIVOT_YEAR_2D = "".concat(PIVOT_YEAR_4D).substr(2, 2); // 70

var NOT_VALID = {
  isValid: false,
  date: null,
  dateRaw: null
};
exports.NOT_VALID = NOT_VALID;

var isValidDate = function isValidDate(date) {
  var _date$getTime;

  return !isNaN(date === null || date === void 0 ? void 0 : (_date$getTime = date.getTime) === null || _date$getTime === void 0 ? void 0 : _date$getTime.call(date));
};
/*
Core function that is called when a validation is defined by { value: String, format: Object }
 */


var isValidDateTimeIntl = function isValidDateTimeIntl(_ref) {
  var value = _ref.value,
      format = _ref.format,
      language = _ref.language;
  var parts = parseDateTimeFromIntl({
    value: value,
    format: format,
    language: language
  }); // splits the value into parts using Intl library.

  var year = parts.year,
      month = parts.month,
      day = parts.day,
      weekday = parts.weekday,
      hour = parts.hour,
      minute = parts.minute,
      second = parts.second,
      hour12 = parts.hour12,
      hourCycle = parts.hourCycle,
      dayPeriod = parts.dayPeriod,
      era = parts.era,
      timeZoneName = parts.timeZoneName;
  var correctedFormat = translate2DigitFormat({
    format: format,
    to2Digit: false
  }); // Transforms all '2-digit' types into 'digit' (will be transformed back soon).

  if (year && !checkIntlYear({
    value: year,
    format: correctedFormat.year
  })) {
    return NOT_VALID;
  }

  if (month && !checkIntlMonth({
    value: month,
    format: correctedFormat.month,
    language: language
  })) {
    return NOT_VALID;
  }

  if (day && !checkIntlDay({
    value: day,
    format: correctedFormat.day,
    language: language,
    month: month,
    year: year
  })) {
    return NOT_VALID;
  }

  if (weekday && !checkIntlWeekDay({
    value: weekday,
    format: correctedFormat.weekday,
    language: language
  })) {
    return NOT_VALID;
  }

  if (hour && !checkIntlHour({
    value: hour,
    format: correctedFormat.hour,
    hourCycle: hourCycle,
    hour12: hour12
  })) {
    return NOT_VALID;
  }

  if (minute && !checkIntlMinute({
    value: minute,
    format: correctedFormat.minute
  })) {
    return NOT_VALID;
  }

  if (second && !checkIntlSecond({
    value: second,
    format: correctedFormat.second
  })) {
    return NOT_VALID;
  }

  if (dayPeriod && !checkIntlAmpm({
    value: dayPeriod
  })) {
    return NOT_VALID;
  }

  if (timeZoneName && !checkIntlTimeZoneName({
    value: timeZoneName,
    timeZone: correctedFormat.timeZone,
    timeZoneName: correctedFormat.timeZoneName,
    year: year,
    month: month,
    day: day,
    monthFormat: correctedFormat.month
  })) {
    return NOT_VALID;
  }

  if (era && !checkIntlEra({
    value: era,
    format: correctedFormat.era,
    year: year,
    yearFormat: correctedFormat.year,
    language: language
  })) {
    return NOT_VALID;
  }

  var _createDate = createDate(_objectSpread(_objectSpread({}, parts), {}, {
    yearFormat: format.year,
    timeZone: format.timeZone,
    timeZoneName: format.timeZoneName
  })),
      date = _createDate.date,
      dateRaw = _createDate.dateRaw; // make sure we won't return an invalid date


  if (!isValidDate(date)) {
    console.warn("Invalid date: ".concat(value, ". Please check the isValidDateTimeIntl function there is likely an \uD83D\uDC1B"));
    return NOT_VALID;
  }

  return {
    isValid: true,
    dateRaw: dateRaw,
    date: date
  };
};
/*
Returns a number of days in a given month. Checks the leap year as well.
 */


exports.isValidDateTimeIntl = isValidDateTimeIntl;

var daysInMonthsBoundaries = function daysInMonthsBoundaries() {
  var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getFullYear();
  return [31, // january
  year && parseInt(year, 10) % 4 === 0 ? 29 : 28, // february
  31, // march
  30, // april
  31, // may
  30, // june
  31, // july
  31, // august
  30, // september
  31, // october
  30, // november
  31 // december
  ];
};
/*
If there is a missing white space char BEFORE dayPeriod, a new one is added there.
 */


var addSpaceBeforeAmpm = function addSpaceBeforeAmpm(value) {
  var index = null;

  if (index !== -1) {
    index = value.toLowerCase().indexOf('am');
  } else {
    index = value.toLowerCase().indexOf('pm');
  }

  if (index !== -1) {
    if (index === 0) {
      return " ".concat(value.toUpperCase());
    }

    if (value[index - 1] !== ' ') {
      return "".concat(value.substr(0, index), " ").concat(value.substr(index, 2).toUpperCase()).concat(value.substr(index + 2, value.length - 2 - index));
    }

    return value.toUpperCase();
  }

  return value.toUpperCase();
};
/*
Basically a parser of value using a given format and a given language.
It creates an Intl formatter, that uses a given format and a language. The date is the current date.
Intl formats this date out and compares the parts with the given value (in a complicated loop).
The result is parsed value-date (object), that might contain invalid values for given keys (such as `month: 34`).
 */


var parseDateTimeFromIntl = function parseDateTimeFromIntl(_ref2) {
  var value = _ref2.value,
      format = _ref2.format,
      language = _ref2.language;
  var date = new Date();
  var formatter = Intl.DateTimeFormat(language, format);
  var fP = formatter.formatToParts(date); // formatterParts

  var fI = 0; // formatterIndex

  var vI = 0; // valueIndex

  var temp = '';
  var valueParts = {};
  var correctedValue = addSpaceBeforeAmpm(value);

  while (fI < fP.length) {
    if (vI === correctedValue.length) {
      if (fI === fP.length - 1) {
        valueParts[fP[fI].type] = temp;
      } else {
        var index = temp.indexOf(fP[fI + 1].value);

        if (index !== -1) {
          valueParts[fP[fI].type] = temp.substr(0, index);
        } else {
          // at the end we should drop any partially matched next literal
          if (fP[fI + 1].type === 'literal') {
            var endIndex = indexOfPartialMatch(temp, fP[fI + 1].value);

            if (endIndex !== -1) {
              temp = temp.substr(0, endIndex);
            }
          }

          valueParts[fP[fI].type] = temp;
        }
      }

      break;
    }

    if (fI + 1 < fP.length && temp.indexOf(fP[fI + 1].value) !== -1) {
      valueParts[fP[fI].type] = temp.split(fP[fI + 1].value)[0];
      temp = correctedValue[vI];
      fI += 2;
    } else {
      temp += correctedValue[vI];
    }

    vI += 1;
  }

  if (Object.prototype.hasOwnProperty.call(format, 'hour12')) {
    valueParts.hour12 = format.hour12;
  }

  if (Object.prototype.hasOwnProperty.call(format, 'hourCycle')) {
    valueParts.hourCycle = format.hourCycle;
  } // note that dayPeriod is added automatically, if a language that supports it is detected.


  if (Object.prototype.hasOwnProperty.call(valueParts, 'dayPeriod')) {
    valueParts.hour12 = true;
  }

  return valueParts;
};

var indexOfPartialMatch = function indexOfPartialMatch(value, suffix) {
  var index = -1;
  var partialSuffix = suffix;

  while (partialSuffix) {
    index = value.indexOf(partialSuffix);

    if (index !== -1) {
      break;
    }

    partialSuffix = partialSuffix.slice(0, -1);
  }

  return index;
};
/*
Returns an index (0-11) of a given month (custom language, custom string).
 */


var getMonthIndexFromString = function getMonthIndexFromString(_ref3) {
  var value = _ref3.value,
      format = _ref3.format,
      language = _ref3.language;
  var date = new Date('1.1.2020');

  var _translate2DigitForma = translate2DigitFormat({
    format: {
      month: format
    },
    to2Digit: true
  }),
      monthFormat = _translate2DigitForma.month.monthFormat;

  var formatter = Intl.DateTimeFormat(language, {
    month: monthFormat
  });

  for (var i = 0; i < 12; i += 1) {
    date.setMonth(i);

    if (formatter.format(date).toLowerCase() === value.toLowerCase()) {
      return i;
    }
  }

  return null;
};
/*
Translates '2-digit' key into 'digit' and vice-versa.
This is because a function name / object key cannot start with a number.
 */


var translate2DigitFormat = function translate2DigitFormat(_ref4) {
  var format = _ref4.format,
      _ref4$to2Digit = _ref4.to2Digit,
      to2Digit = _ref4$to2Digit === void 0 ? true : _ref4$to2Digit;

  var result = _objectSpread({}, format);

  Object.keys(format).forEach(function (prop) {
    if (to2Digit) {
      if (Object.prototype.hasOwnProperty.call(format, prop) && format[prop] === 'digit') {
        result[prop] = '2-digit';
      }
    } else if (Object.prototype.hasOwnProperty.call(format, prop) && format[prop] === '2-digit') {
      result[prop] = 'digit';
    }
  });
  return result;
};
/*
Returns an object of array detected by a `part` key. Used when parsing Intl date.
 */


var findPartByType = function findPartByType(_ref5) {
  var parts = _ref5.parts,
      type = _ref5.type;

  for (var i = 0; i < parts.length; i += 1) {
    if (parts[i].type === type) {
      return parts[i];
    }
  }

  return null;
};
/*
Returns a string with a fixed length. Input can be either number or string.
 */


var fixDigits = function fixDigits(number) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var string = "".concat(number);

  if (string.length < digits) {
    return "".concat('0'.repeat(digits - string.length)).concat(string);
  }

  if (string.length === digits) {
    return string;
  }

  return "".concat(string.substr(0, digits));
};
/*
Checks whether the input is either a Number (instance) or a String that only contains number (or Integer with a `-` symbol).
 */


var isNumber = function isNumber(input) {
  return Number.isInteger(input) || input && input.length ? Number.isInteger(input) || /^-{0,1}\d+$/.test(input) : false;
};
/*
Checks whether the input does not exceed the given boundaries. Used when checking whether a dayValue is in [1,31] for instance.
 */


exports.isNumber = isNumber;

var inLimit = function inLimit(_ref6) {
  var value = _ref6.value,
      boundaries = _ref6.boundaries;
  return boundaries ? value >= boundaries[0] && value <= boundaries[1] : true;
};
/*
Basically unifies isNumber and inLimit functions.
 */


var validNumberInLimits = function validNumberInLimits(_ref7) {
  var value = _ref7.value,
      boundaries = _ref7.boundaries;
  return isNumber(value) && inLimit({
    value: value,
    boundaries: boundaries
  });
};
/*
Checks whether a stringValue with given format and language is in array of validValues.
ValidValues is a function that returns an array of permitted strings, such as getWeekDays(), getMonths(), ...
 */


var validateStringFormOfValue = function validateStringFormOfValue(_ref8) {
  var value = _ref8.value,
      format = _ref8.format,
      language = _ref8.language,
      validValues = _ref8.validValues;
  return validValues({
    format: format,
    locale: language,
    lowerCase: true
  }).indexOf(value.toLowerCase()) !== -1;
};
/*
Returns an index (0-11) of a given month (either a number or a string).
If the given value is lets say `2` (which stands for February), it return `1`.
 */


var getMonthIndex = function getMonthIndex(_ref9) {
  var format = _ref9.format,
      language = _ref9.language,
      value = _ref9.value;

  if (!value) {
    return null;
  }

  if (isNumber(value)) {
    if (Object.prototype.hasOwnProperty.call(intlFormatDefaults, format)) {
      var parsedValue = parseInt(value, 10) - 1;

      var _validValue = intlFormatDefaults[format]({
        value: parsedValue,
        boundaries: [0, 11]
      });

      return _validValue ? parsedValue : null;
    }

    return null;
  }

  var validValue = intlFormatMonths[format]({
    value: value,
    format: format,
    language: language
  }) || null;
  return validValue ? getMonthIndexFromString({
    value: value,
    format: format,
    language: language
  }) : null;
};
/*
Detects the difference between the local timeZone and a given timeZone and changes the given date.
Since it is not possible to change a timeZone in a JS Date, there is a little hack - the date object holds its timeZone, however, the hours are changed.
This whole function is called only when everything is correct - so in addition to this date object,
there is also a `rawDate` string returned (in a different function),
that holds the correct timeZone and is designed for developers to use (if they want to process the timeZones).
 */


var convertToCorrectTimeZone = function convertToCorrectTimeZone(_ref10) {
  var timeZone = _ref10.timeZone,
      result = _ref10.result;
  var currentDate = new Date();
  var currentUTCDate = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds()));
  var timeZoneDate = new Date(currentUTCDate.toLocaleString('en', {
    timeZone: timeZone
  }));
  var timeZoneOffset = (timeZoneDate - currentUTCDate) / 60000; // difference in milliseconds for offset

  result.setTime(result.getTime() + timeZoneOffset);
};

var checkIntlYear = function checkIntlYear(_ref11) {
  var value = _ref11.value,
      format = _ref11.format;

  if (!isNumber(value)) {
    return false;
  }

  return intlFormatDefaults[format]({
    value: parseInt(value, 10),
    boundaries: [0, 9999]
  }) || false;
};

exports.checkIntlYear = checkIntlYear;

var checkIntlMonth = function checkIntlMonth(_ref12) {
  var value = _ref12.value,
      format = _ref12.format,
      language = _ref12.language;

  if (!isNumber(value)) {
    return false;
  }

  return getMonthIndex({
    format: format,
    language: language,
    value: value
  }) !== null;
};

exports.checkIntlMonth = checkIntlMonth;

var checkIntlWeekDay = function checkIntlWeekDay(_ref13) {
  var value = _ref13.value,
      format = _ref13.format,
      language = _ref13.language;
  return intlFormatWeekDays[format]({
    value: value,
    format: format,
    language: language
  }) || false;
};

var checkIntlDay = function checkIntlDay(_ref14) {
  var value = _ref14.value,
      format = _ref14.format,
      month = _ref14.month,
      year = _ref14.year,
      language = _ref14.language;

  if (!isNumber(value)) {
    return false;
  }

  var maxDaysInMonth = daysInMonthsBoundaries(year)[getMonthIndex({
    format: format,
    language: language,
    value: month
  })];
  return intlFormatDefaults[format]({
    value: parseInt(value, 10),
    boundaries: [1, maxDaysInMonth]
  }) || false;
};

exports.checkIntlDay = checkIntlDay;

var checkIntlHour = function checkIntlHour(_ref15) {
  var value = _ref15.value,
      format = _ref15.format,
      hour12 = _ref15.hour12,
      _ref15$hourCycle = _ref15.hourCycle,
      hourCycle = _ref15$hourCycle === void 0 ? 'h23' : _ref15$hourCycle;

  if (!isNumber(value)) {
    return false;
  }

  if (hourCycle) {
    // hourCycle has higher priority than `hour12` according to Intl docs.
    return IntlFormatHours[hourCycle]({
      value: value,
      format: format
    });
  }

  if (hour12) {
    return IntlFormatHours.h12({
      value: value,
      format: format
    });
  } // 0-23 hours format is default.


  return IntlFormatHours.h23({
    value: value,
    format: format
  });
};

var checkIntlMinute = function checkIntlMinute(_ref16) {
  var value = _ref16.value,
      format = _ref16.format;

  if (!isNumber(value)) {
    return false;
  }

  return intlFormatDefaults[format]({
    value: parseInt(value, 10),
    boundaries: [0, 59]
  }) || false;
};

exports.checkIntlMinute = checkIntlMinute;

var checkIntlSecond = function checkIntlSecond(_ref17) {
  var value = _ref17.value,
      format = _ref17.format;

  if (!isNumber(value)) {
    return false;
  }

  return intlFormatDefaults[format]({
    value: parseInt(value, 10),
    boundaries: [0, 59]
  }) || false;
};

exports.checkIntlSecond = checkIntlSecond;

var checkIntlAmpm = function checkIntlAmpm(_ref18) {
  var value = _ref18.value;
  return ['am', 'pm'].indexOf(value.toLowerCase()) !== -1;
};

var checkIntlTimeZoneName = function checkIntlTimeZoneName(_ref19) {
  var value = _ref19.value,
      timeZone = _ref19.timeZone,
      timeZoneName = _ref19.timeZoneName,
      language = _ref19.language,
      _ref19$month = _ref19.month,
      month = _ref19$month === void 0 ? new Date().getMonth() + 1 : _ref19$month,
      _ref19$day = _ref19.day,
      day = _ref19$day === void 0 ? new Date().getDate() : _ref19$day,
      _ref19$year = _ref19.year,
      year = _ref19$year === void 0 ? new Date().getFullYear() : _ref19$year,
      monthFormat = _ref19.monthFormat;
  var timeZoneFormat = {
    timeZone: timeZone
  } || null;
  var timeZoneNameFormat = {
    timeZoneName: timeZoneName
  } || null;
  var formatter = new Intl.DateTimeFormat(language, _objectSpread(_objectSpread({}, timeZoneFormat), timeZoneNameFormat)); // Since a simple timeZone just cannot be displayed alone, some more Date() parts are needed ...
  // Also, due to sunlight saving, timeZones are changing, therefore, a day/month/year parts are chosen for this trick.

  var date = new Date();
  date.setFullYear(year);
  date.setMonth(isNumber(month) ? parseInt(month, 10) - 1 : getMonthIndex({
    format: monthFormat,
    language: language,
    month: month
  }));
  date.setDate(day);
  var parts = formatter.formatToParts(date);
  return value.toLowerCase() === parts[parts.length - 1].value.toLowerCase();
};
/*
This might be a very unused functionality, however, we are supporting all the Intl formats...
 */


var checkIntlEra = function checkIntlEra(_ref20) {
  var value = _ref20.value,
      format = _ref20.format,
      year = _ref20.year,
      yearFormat = _ref20.yearFormat,
      language = _ref20.language;
  var formatter = new Intl.DateTimeFormat(language, {
    era: format,
    yearFormat: yearFormat
  });
  var date = new Date();
  date.setFullYear(year);
  var parts = formatter.formatToParts(date);
  var eraPart = findPartByType({
    parts: parts,
    type: 'era'
  }).value;
  return value.toLowerCase() === eraPart.toLowerCase();
};
/*
Functions that are called while checking - depends on the format of the checked part.
Those are the basic ones.
 */


var intlFormatDefaults = {
  numeric: validNumberInLimits,
  digit: function digit(_ref21) {
    var value = _ref21.value,
        boundaries = _ref21.boundaries;
    return validNumberInLimits({
      value: value,
      boundaries: boundaries
    }) && "".concat(value).length <= 2;
  }
};
/*
Functions that are called while checking - depends on the format of the checked part.
Those are for the month.
 */

var intlFormatMonths = {
  long: function long(_ref22) {
    var value = _ref22.value,
        format = _ref22.format,
        language = _ref22.language;
    return validateStringFormOfValue({
      value: value,
      format: format,
      language: language,
      getMonths: _utils.getMonths
    });
  },
  short: function short(_ref23) {
    var value = _ref23.value,
        format = _ref23.format,
        language = _ref23.language;
    return validateStringFormOfValue({
      value: value,
      format: format,
      language: language,
      getMonths: _utils.getMonths
    });
  },
  narrow: function narrow(_ref24) {
    var value = _ref24.value,
        format = _ref24.format,
        language = _ref24.language;
    return validateStringFormOfValue({
      value: value,
      format: format,
      language: language,
      getMonths: _utils.getMonths
    });
  }
};
/*
Functions that are called while checking - depends on the format of the checked part.
Those are for the weekdays.
 */

var intlFormatWeekDays = {
  long: function long(_ref25) {
    var value = _ref25.value,
        format = _ref25.format,
        language = _ref25.language;
    return validateStringFormOfValue({
      value: value,
      format: format,
      language: language,
      getWeekDays: _utils.getWeekDays
    });
  },
  short: function short(_ref26) {
    var value = _ref26.value,
        format = _ref26.format,
        language = _ref26.language;
    return validateStringFormOfValue({
      value: value,
      format: format,
      language: language,
      getWeekDays: _utils.getWeekDays
    });
  },
  narrow: function narrow(_ref27) {
    var value = _ref27.value,
        format = _ref27.format,
        language = _ref27.language;
    return validateStringFormOfValue({
      value: value,
      format: format,
      language: language,
      getWeekDays: _utils.getWeekDays
    });
  }
};
/*
Functions that are called while checking - depends on the format of the checked part.
Those are for the hours.
 */

var IntlFormatHours = {
  h11: function h11(_ref28) {
    var value = _ref28.value,
        format = _ref28.format;
    return intlFormatDefaults[format]({
      value: parseInt(value, 10),
      boundaries: [0, 11]
    });
  },
  h12: function h12(_ref29) {
    var value = _ref29.value,
        format = _ref29.format;
    return intlFormatDefaults[format]({
      value: parseInt(value, 10),
      boundaries: [1, 12]
    });
  },
  h23: function h23(_ref30) {
    var value = _ref30.value,
        format = _ref30.format;
    return intlFormatDefaults[format]({
      value: parseInt(value, 10),
      boundaries: [0, 23]
    });
  },
  h24: function h24(_ref31) {
    var value = _ref31.value,
        format = _ref31.format;
    return intlFormatDefaults[format]({
      value: parseInt(value, 10),
      boundaries: [1, 24]
    });
  }
};
/*
A function that is called when the validation is done and the value is valid.
The whole validation is supposed to return and object consisted of a Date object and a rawDate string value (ISO date).
It basically creates a new (current) date and simply step by step changing its values.
Values are gotten from the parsed format. Only those values/formats, which were given at the beginning, are changed.
Other values and current.
 */

var createDate = function createDate() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var day = values.day,
      month = values.month,
      year = values.year,
      hour = values.hour,
      minute = values.minute,
      second = values.second,
      hour12 = values.hour12,
      timeZone = values.timeZone,
      dayPeriod = values.dayPeriod,
      yearFormat = values.yearFormat;
  var result = new Date();

  if (day) {
    result.setDate(day);
  }

  if (month) {
    result.setMonth(parseInt(month, 10) - 1);
  }

  if (year) {
    if (yearFormat === '2-digit') {
      var intYear = parseInt(year, 10);
      var correctYear = intYear < PIVOT_YEAR_2D ? 2000 + intYear : 1900 + intYear;
      result.setFullYear(correctYear);
    } else {
      result.setFullYear(year);
    }
  }

  if (minute) {
    result.setMinutes(minute);
  }

  if (second) {
    result.setSeconds(second);
  }

  if (hour) {
    var parsedHours = hour12 && dayPeriod.toLowerCase() === 'pm' ? parseInt(hour, 10) + 12 : parseInt(hour, 10);
    result.setHours(parsedHours);

    if (timeZone) {
      convertToCorrectTimeZone({
        timeZone: timeZone,
        result: result
      });
    }
  }

  var dateRaw = "".concat(fixDigits(result.getFullYear(), 4), "-").concat(fixDigits(result.getMonth() + 1), "-").concat(fixDigits(result.getDate()), "T").concat(fixDigits(result.getHours()), ":").concat(fixDigits(result.getMinutes()), ":").concat(fixDigits(result.getSeconds()), ".000Z");
  return {
    date: result,
    dateRaw: dateRaw
  };
};
//# sourceMappingURL=intl-formats.js.map